import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormTextareaComponent } from '@pishgamrayan/ng-form-kit';

import { ShareDirectivesModule } from '../../../../core/directives/directives.module';
import { SharePipesModule } from '../../../../core/pipes/pipes.module';
import { TranslationModule } from '../../../../i18n/translation.module';
import { MaterialModule } from '../../../modules/material/material.module';
import { FileUploaderModule } from '../../file-uploader/file-uploader.module';
import { PdfReaderModule } from '../../pdf-reader/pdf-reader.module';
import { EnumSelectSearchComponent } from '../../select-search/enum-select-search.component';
import { ShowImagesModule } from '../../show-images/show-images.module';
import { ShowDocumentsComponent } from './show-documents.component';

@NgModule({
  declarations: [ShowDocumentsComponent],
  imports: [
    CommonModule,
    MaterialModule,
    NgbModule,
    FormsModule,
    ShareDirectivesModule,
    ReactiveFormsModule,
    TranslationModule,
    SharePipesModule,
    FileUploaderModule,
    ShowImagesModule,
    PdfReaderModule,
    EnumSelectSearchComponent,
    FormTextareaComponent,
  ],
  exports: [ShowDocumentsComponent],
})
export class ShowDocumentsModule {}
